import React, { type PropsWithChildren } from "react"
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { store, persistor, setupStore, RootState, AppStore, useAppSelector } from './Store'

import { Client as Styletron } from "styletron-engine-monolithic"
import { Provider as StyletronProvider } from "styletron-react"
import { DarkTheme, BaseProvider } from "baseui"

import { render, type RenderOptions } from "@testing-library/react"

import "./Assets/Fonts/fonts.css"
import { colors } from "./Styles/index"

import { CookieModal } from "./Components"

import "./Styles/reset.css"


/* TODO: ApolloConnectors Should only be initilazed after login is confirmed */
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, ApolloProvider, NormalizedCacheObject } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { removeTypenameFromVariables } from "@apollo/client/link/remove-typename";
import { MainNavigator } from "./Navigation/Routers"

import {default as BaseOverlay} from "./Components/baseOverlay"

export const IS_CLOUD = process.env.REACT_APP_CLOUD_BUILD ? Boolean(process.env.REACT_APP_CLOUD_BUILD) : false; 

interface ExtendedRenderOptions extends Omit<RenderOptions, "queries"> {
  preloadedState?: Partial<RootState>
  store?: AppStore,
  client?: ApolloClient<NormalizedCacheObject>
}

//import { Suspense } from 'react'
//App.logout().then(() => client.resetStore());   //clearStore

//const origin = process.env.REACT_APP_GRAPHQL_ADDRESS ? process.env.REACT_APP_GRAPHQL_ADDRESS: `${window.location.protocol}//${window.location.hostname}:${process.env.REACT_APP_GRAPHQL_PORT ?? "4000"}` 
const baseOrigin = process.env.REACT_APP_GRAPHQL_ADDRESS ? process.env.REACT_APP_GRAPHQL_ADDRESS: `${window.location.protocol}//${window.location.hostname}/` 

const internalHttpLink = new HttpLink({
  uri: baseOrigin + 'internal/',
  fetchOptions: { mode: 'cors' }
})

const legacyHttpLink = new HttpLink({
  uri: baseOrigin + 'legacy/',
  fetchOptions: { mode: 'cors' }
})

const splitLink = ApolloLink.split(
  (operation) => {
    const context = operation.getContext()
    return context.clientName === 'legacy'
  },
  legacyHttpLink,    // if true → go to legacy
  internalHttpLink   // else → go to internal
)

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  
  var token = localStorage.getItem('token')
  var activeDomain = localStorage.getItem('activedomain')
  const activeDomainFromStore = store.getState().activeData.farm;
  const activedomain = activeDomainFromStore ?? activeDomain ?? "";
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': "true",
      token: process.env.REACT_APP_GRAPHQL_TOKEN?process.env.REACT_APP_GRAPHQL_TOKEN:'Very_Secret',
      authorization: token ? token : "",
      activedomain,
    }
  }
})

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        // controller: {
        //   merge(existing, incoming, {mergeObjects}) {
        //     console.debug(existing, incoming);
        //     console.debug(mergeObjects(existing, incoming))
        //     return {...existing, ...incoming} //controllerLogsAico: [...existing.controllerLogsAico, ...incoming.controllerLogsAico]};
        //   }
        // }
        /*getOnlineState: {
          // Don't cache separate results based on any of this field's arguments.
          keyArgs: false,
          // Concatenate the incoming list items with the existing list items.
          merge(existing = [], incoming) {
            return [...existing, incoming]
          },
        }*/
      }
    },
    // ControllerQueries: {
    //   fields: {
    //     controllerLogsAico: {
    //       merge(existing, incoming) {
    //         console.debug(existing, incoming);
    //         return {...existing, ...incoming};
    //       }
    //     }
    //   }
    // }
  }
})

const removeTypenameLink = removeTypenameFromVariables();


const setupApolloClient = () => new ApolloClient({
  //uri: process.env.REACT_APP_GRAPHQL_ADDRESS,
  link: ApolloLink.from([authLink, removeTypenameLink, splitLink]), // authLink.concat(httpLink), ??
  cache: cache,
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    }
  },
 
})

const Wrapper = ({ children }:PropsWithChildren, store:any, client:ApolloClient<NormalizedCacheObject>) => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <StyletronProvider value={new Styletron()}>
        {/* <BaseProvider
          theme={DarkTheme}
          zIndex={999}
          overrides={{
            AppContainer:{
              style: () => ({
                outline: `0px #000 solid`,
                backgroundColor: colors.greyDarkSecondary, 
                position: 'absolute',
                top: 0, left: 0, bottom: 0, right: 0,
                height: '100%', width: '100%', default: {height: '100%', width: '100%'},
                overflow: "hidden"
              })
            },
          }}> */}
          <ApolloProvider client={client} >
            {children}
            {process.env.REACT_APP_SNOW_FAll && (<BaseOverlay/>)}
            <CookieModal/>
          </ApolloProvider>
        {/* </BaseProvider> */}
      </StyletronProvider>
    </PersistGate>
  </Provider>
)

export function renderWithProviders( ui: React.ReactElement, extendedRenderOptions: ExtendedRenderOptions = {}) {
  const {
    preloadedState = {},
    // Automatically create a store instance if no store was passed in
    store = setupStore(preloadedState),
    client = setupApolloClient(),
    ...renderOptions
  } = extendedRenderOptions

  // Return an object with the store and all of RTL's query functions
  return { 
    store, client, 
    ...render(ui, { wrapper: (e) => Wrapper(e, store, client), ...renderOptions }) 
  }
}

export function AgrisysApp():JSX.Element {
  return Wrapper({children:<MainNavigator/>}, store, setupApolloClient())
}
